
import {Component, Inject, Prop, Vue} from 'vue-property-decorator';
import VuePerfectScrollbar from 'vue-perfect-scrollbar/index.vue';

@Component({
  components: {VuePerfectScrollbar},
})
export default class AlertDialogFrame extends Vue {
  @Prop(String) public questionHeader;
  @Prop(String) public questionBody;

  @Inject('agree') private agree!: any;
  @Inject('cancel') private cancel!: any;

  public get scrollSettings() {
    return {
      maxScrollbarLength: 120,
    };
  }

}
